import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  stationManagerNumber,
  sendNotification,
} from "../../actions/commonActions";
import "../../css/style-starter.css";
import Loading from "../Shared/Loading";

export default function Contact() {
  const { stationManagerNumberList, showToast } = useSelector(
    (redux) => redux.common
  );
  const [userName, setUserName] = useState({
    first_name: "",
    last_name: "",
  });
  const dispatch = useDispatch();

  const [driverId, setDriverId] = useState("");
  const [loading, setLoading] = useState(false);
  const [notificationText, setNotificationText] = useState("");
  const [stationManager, setStationManager] = useState([]);
  const [evChargingSiteID, setEvChargingSiteID] = useState(null);

  useEffect(() => {
    const driver_id = localStorage.getItem("driver_id");
    setDriverId(driver_id);
    stationManagerNumber(dispatch, driver_id);
    setUserName({
      first_name: localStorage.getItem("first_name"),
      last_name: localStorage.getItem("last_name"),
    });
    setEvChargingSiteID(localStorage.getItem("ev_charging_site_id"));
  }, []);

  useEffect(() => {
    if (stationManagerNumberList.length > 0) {
      setStationManager(
        stationManagerNumberList.filter(
          (s) => s.ev_charging_site_id == evChargingSiteID
        )
      );
    }
  }, [stationManagerNumberList]);

  useEffect(() => {
    if (showToast.display == true) {
      setNotificationText("");
      setLoading(false);
    }
  }, [showToast]);

  const onSubmitNotification = (e) => {
    e.preventDefault();
    setLoading(true);
    sendNotification(dispatch, {
      ev_charging_site_id: evChargingSiteID,
      notification_text: notificationText,
      from_user_account_id: localStorage.getItem("driver_id"),
    });
  };

  return (
    <div className={`cbp-spmenu-push`}>
      <div className="main buttonset">
        <div className="tophny-header">
          <div className="container">
            <div className="hny-topgds">
              <div className="menu-notify"></div>
              <div className="logo text-center">
                <h1>
                  <a className="navbar-brand" href="#">
                    {` ${userName.first_name} ${userName.last_name}`}
                  </a>
                </h1>
              </div>
              {/* <div className="icon-left search-right text-right">
                <NavLink to={`/profile/${driverId}`} className="topuser">
                  <span className="fa fa-user" aria-hidden="true"></span>
                </NavLink>
              </div> */}
            </div>
          </div>
        </div>
        <section className="features-4" id="services">
          <div className="features4-block ">
            <div className="container py-lg-3 py-5">
              <div className="title-head text-center mb-lg-5 mb-4">
                <h3 className="hny-title">
                  <span>Contact My Station Manager</span>{" "}
                </h3>
              </div>
            </div>
          </div>
        </section>
        <section className="content-4">
          <div className="content-4-main py-5">
            <div className="container py-lg-5">
              <div className="title-head text-center mb-4">
                {(stationManager.length > 0 && (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      // *********************  Mobile app stuff ***********************
                      const phonenumber = stationManager[0].phone_number;
                      // For Android
                      if (window.androidObj == undefined) {
                        window.androidObj = function AndroidClass() {};
                      }

                      if (window.androidObj.dialCall !== undefined) {
                        window.androidObj.dialCall(phonenumber);
                      }
                      //  =================IOS======================================
                      if (window.webkit) {
                        window.webkit.messageHandlers.dialCall.postMessage({
                          phonenumber,
                        });
                      }
                      //  ===========================================================
                    }}
                    // href={`tel:${stationManagerNumberList[0].phone_number}`}
                  >
                    {stationManager[0].phone_number}
                  </button>
                )) || <p>Station Manager's number not available</p>}
                <br />
              </div>
            </div>
          </div>
          <div className="container mt-3">
            <form onSubmit={onSubmitNotification}>
              <div className="from-group">
                <textarea
                  className="form-control"
                  value={notificationText}
                  onChange={(e) => {
                    setNotificationText(e.target.value);
                  }}
                  placeholder="Send Notification to station manager"
                ></textarea>
              </div>
              <div className="form-group mt-2">
                <button type="submit" className="btn btn-info float-right">
                  {(loading && <Loading style={{ height: "30px" }} />) ||
                    "Send"}
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
}
